import React, { useContext } from 'react';
import { node } from 'prop-types';
import { LiveAriaContext } from '@shared_modules/live-aria-a11y/LiveAria';

const Title = props => {
  const liveAriaContext = useContext(LiveAriaContext);
  const refText = liveAriaContext?.refText;

  return (
    <h1 className="title-text" data-qa-id="title-text" ref={refText}>
      {props.children}
    </h1>
  );
};

Title.propTypes = {
  children: node.isRequired,
};

export default Title;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/rc-title/Title.scss');